import Vue from "vue";
import Vuex from "vuex";
Vue.use(Vuex);
const state = {
  // 是否清除过上下文
  hasClear: false,
  // 是否是微信小程序
  isWechatProgram: false,
  // 是否是安卓
  IsAndroid: false,
  // 是否是IOS
  IsIos: false,
  // 当前的渠道code
  channelCode: null,
  // 新对话的配置信息
  newChatInfo: null,
  // 默认对话配置信息
  defaultChatInfo: null,
  // 文件最大上传数
  maxUploadCnt: 0,
  bottomNavType: 1,
  // 支持上传的文件类型
  allowedFileTypes: [],
  // 支持上传的文件分类型控制大小
  fileUploadConfig: [],

  // 今日已使用会话条数
  currentCount: 0,
  // 今日总会话条数
  totalCount: 0,
  // 今日已使用会话字数
  currentTokenCount: 0,
  // 今日总会话字数
  totalTokenCount: 0,
  // 今日已使用会话字数
  vipTotalCount: 0,
};
const getters = {
  hasClear: function (state) {
    return state.hasClear;
  },
  isWechatProgram: function (state) {
    return state.isWechatProgram;
  },
  IsAndroid: function (state) {
    return state.IsAndroid;
  },
  IsIos: function (state) {
    return state.IsIos;
  },
  channelCode: function (state) {
    return state.channelCode;
  },
  newChatInfo: function (state) {
    return state.newChatInfo;
  },
  defaultChatInfo: function (state) {
    return state.defaultChatInfo;
  },
  maxUploadCnt: function (state) {
    return state.maxUploadCnt;
  },
  bottomNavType: function (state) {
    return state.bottomNavType;
  },
  allowedFileTypes: function (state) {
    return state.allowedFileTypes;
  },
  fileUploadConfig: function (state) {
    return state.fileUploadConfig;
  },
  currentCount: function (state) {
    return state.currentCount;
  },
  totalCount: function (state) {
    return state.totalCount;
  },
  currentTokenCount: function (state) {
    return state.currentTokenCount;
  },
  totalTokenCount: function (state) {
    return state.totalTokenCount;
  },
  vipTotalCount: function (state) {
    return state.vipTotalCount;
  },
};
const mutations = {
  hasClear: function (state, hasClear) {
    state.hasClear = hasClear;
  },
  isWechatProgram: function (state, isWechatProgram) {
    state.isWechatProgram = isWechatProgram;
  },
  IsAndroid: function (state, IsAndroid) {
    state.IsAndroid = IsAndroid;
  },
  IsIos: function (state, IsIos) {
    state.IsIos = IsIos;
  },
  channelCode: function (state, channelCode) {
    state.channelCode = channelCode;
  },
  newChatInfo: function (state, newChatInfo) {
    state.newChatInfo = newChatInfo;
  },
  defaultChatInfo: function (state, defaultChatInfo) {
    state.defaultChatInfo = defaultChatInfo;
  },
  maxUploadCnt: function (state, maxUploadCnt) {
    state.maxUploadCnt = maxUploadCnt;
  },
  bottomNavType: function (state, bottomNavType) {
    state.bottomNavType = bottomNavType;
  },
  allowedFileTypes: function (state, allowedFileTypes) {
    state.allowedFileTypes = allowedFileTypes;
  },
  fileUploadConfig: function (state, fileUploadConfig) {
    state.fileUploadConfig = fileUploadConfig;
  },
  currentCount: function (state, currentCount) {
    state.currentCount = currentCount;
  },
  totalCount: function (state, totalCount) {
    state.totalCount = totalCount;
  },
  currentTokenCount: function (state, currentTokenCount) {
    state.currentTokenCount = currentTokenCount;
  },
  totalTokenCount: function (state, totalTokenCount) {
    state.totalTokenCount = totalTokenCount;
  },
  vipTotalCount: function (state, vipTotalCount) {
    state.vipTotalCount = vipTotalCount;
  },
};
export default new Vuex.Store({
  state,
  mutations,
  getters,
});
